import React, { useEffect, useReducer, useRef, useState } from 'react';

import config from '../config.json'

import { getFeatureLayers, getListasResumenBase, loadWebMapAndLayers, urlTableroEsValida } from "../utils/mapaUtils";
import WidgetCerca from './widgets/widgetCerca';
import WidgetFiltro from './widgets/widgetFiltro';

import RefsContext from '../contexts/RefsContext';

import ListaResumenContext from '../contexts/ListaResumenContext';
import { EstadosWidgets } from '../classes/reducerClasses';
import { CustomWidgetsRefs } from '../classes/widgetClasses';
import { reducerEstadosWidgets, reducerListaResumenCerca } from '../utils/reducerUtils';
import { descargarArchivo } from '../utils/domUtils';
import PanelInfoLayer from './panelInfoLayer';

function Visor({ parametros, parametrosVisor, setSeccionesNavegarVisible }) {

    const [widgetsCargados, setWidgetsCargados] = useState(false);
    const mapViewRef = useRef(null);
    const expandsWidgetsButtonsRef = useRef(null);
    const [estadosWidgets, dispatchEstadosWidgets] = useReducer(reducerEstadosWidgets, new EstadosWidgets(false, false, null));
    const [listaResumenCerca, dispatchListaResumenCerca] = useReducer(reducerListaResumenCerca, null);
    const [listasResumenBase, setlistasResumenBase] = useState(null);
    const [infoLayer, setInfoLayer] = useState(null);
    const divMapViewRef = useRef(null);
    const divWidgetTableroRef = useRef(null);
    const divWidgetCercaRef = useRef(null);
    const divWidgetFiltroRef = useRef(null);
    const divWidgetInfoRef = useRef(null);

    //Carga WebMap y listasResumenBase
    useEffect(() => {
      loadWebMapAndLayers(parametrosVisor).then((webMap) =>{
        const listasResumenBase = getListasResumenBase(webMap);
        setlistasResumenBase([...listasResumenBase]);
      });
    }, [parametrosVisor])

    //Carga dinámica del mapView
    useEffect(() => {
      if (!listasResumenBase){
        return;
      }
      let cleanup;
      import("../configvisores/mapa").then(mapa => {
        const mapaMaster = new mapa.MapaMaster(
          divMapViewRef.current,
          parametrosVisor,
          mapViewRef,
          expandsWidgetsButtonsRef,
          setWidgetsCargados,
          setInfoLayer,
          cerrarInfoAdicional,
          dispatchListaResumenCerca,
          dispatchEstadosWidgets,
          new CustomWidgetsRefs(divWidgetCercaRef, divWidgetFiltroRef, divWidgetInfoRef, divWidgetTableroRef),
          parametros
        )
        cleanup = mapaMaster.inicializar();
      })
      return () => cleanup && cleanup();
    }, [parametros, listasResumenBase, parametrosVisor]);

    useEffect(() => {
      if (widgetsCargados){
        setSeccionesNavegarVisible(true);
      }
    }, [setSeccionesNavegarVisible, widgetsCargados])

    function cerrarTablero(){
      expandsWidgetsButtonsRef.current.expands.tablero.container.click();
    }

    function cerrarInfoAdicional(){
      if (divWidgetInfoRef.current.style.display === "block"){
        expandsWidgetsButtonsRef.current.expands.info.container.click();
      }
    }

    function instantaneaMapa(){
      mapViewRef.current && mapViewRef.current.takeScreenshot().then(function (screenShot) {
        const image = screenShot.dataUrl.replace("image/png", "image/octet-stream");
        descargarArchivo(image, "VisorGeograficoOnl.png");
      });
    }

    const datosInfoAdicional = parametrosVisor.infoAdicional?.split("|");
    return (
      <RefsContext.Provider value={{ mapViewRef, expandsWidgetsButtonsRef }}>
        <ListaResumenContext.Provider value={{ dispatchListaResumenCerca }}>
          <div className="divMapView" ref={divMapViewRef}></div>          
          <div className="panelAviso panelTitulo" onClick={instantaneaMapa} title="Imagen instantánea" style={{cursor:"pointer"}}>
            {parametrosVisor.nombre}
          </div>
          <div ref={divWidgetTableroRef} style={{ display: "none" }} className="panelTablero">
            <div className="panelTableroEncabezado">
              <div>
                {parametrosVisor.nombre}
              </div>
              <button className="botonCerrar" onClick={cerrarTablero}>✖</button>
            </div>
            <div className='panelTableroFrame'>
              {
                urlTableroEsValida(parametrosVisor.urlTablero) ?
                <iframe title={`tablero.${parametrosVisor.codigoSeccion + "." + parametrosVisor.codigoVisor}`} src={parametrosVisor.urlTablero}/>
                :
                "La URL del tablero no está configurada correctamente"
              }
            </div>
          </div>
          {
            !infoLayer ? null:
            <PanelInfoLayer
              infoLayer={infoLayer}
              setInfoLayer={setInfoLayer}
              cambio={estadosWidgets[EstadosWidgets.propInfoLayerCambio]} //El parámetro cambio se requiere así no se use en el componente, se cambia cuando hay un cambio en el widget y así se hace una nueva renderización
            />
          }
          <div ref={divWidgetInfoRef} style={{ display: "none" }} className="panelAviso panelCentrado panelInfoLayerOrVisor">
            <div className='panelLayerOrVisorEncabezado'>
              <div>
                Acerca de este visor
              </div>
              <button className="botonCerrar" onClick={cerrarInfoAdicional}>✖</button>
            </div>
            <div className="listaDetalleLayerOrVisor">
                {
                    datosInfoAdicional ? datosInfoAdicional.map((x, index) => 
                        <div key={index} className="itemListaDetalleLayerOrVisor">
                            <span className="valorItemListaDetalleLayerOrVisor">{x}</span>
                        </div>
                    ) : 
                    <div className="itemListaDetalleLayerOrVisor">
                      <span className="labelItemListaDetalleLayerOrVisor">{"Aviso"}</span>
                      <span className="valorItemListaDetalleLayerOrVisor">{"No hay información adicional disponible para este visor"}</span>
                    </div>
                }
            </div>
          </div>
          <div ref={divWidgetCercaRef} style={{ display: "none" }}>
            {
              widgetsCargados && listasResumenBase ? 
              <WidgetCerca 
                featureLayers={getFeatureLayers(mapViewRef.current.map).filter(x => listasResumenBase.map(y => y.idLayer).includes(x.id))}
                cambio={estadosWidgets[EstadosWidgets.propCercaCambio]} //El parámetro cambio se requiere así no se use en el componente, se cambia cuando hay un cambio en el widget y así se hace una nueva renderización
                listaResumenCerca={listaResumenCerca}
                maximoItems={parametros[config.parametrosCodigos.listaResumen.maximoItems]}
              /> 
              : null 
            }
          </div>
          <div ref={divWidgetFiltroRef} style={{ display: "none" }}>
            {
              widgetsCargados && listasResumenBase ?
              <WidgetFiltro
                zoomPuntoUnico={parametros[config.parametrosCodigos.filtro.filtroZoomPuntoUnico]}
                idLayerClear={estadosWidgets[EstadosWidgets.propIdLayerClearEnFiltro]}
                dispatchEstadosWidgets={dispatchEstadosWidgets}
              /> : null 
            }
          </div>
        </ListaResumenContext.Provider>
      </RefsContext.Provider>
    ) 
}

export default Visor;